import { createCustomSelector } from '../../domain/utils/react-reselect'
import { selectItineraryState } from './itinerary.selectors'

export const selectActivePoisOnRoute = createCustomSelector(selectItineraryState, itinerary => itinerary?.poisOnRoute)

export const selectHasPoisOnRoute = createCustomSelector(selectActivePoisOnRoute, poisOnRoute => Boolean(poisOnRoute))
